import { BUTTON_CLASSES } from 'common/vue/Data/Constants/buttonClasses';
export default {
    root: function (_a) {
        var props = _a.props;
        return ({
            class: [
                {
                    'tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-2': props.mode === 'basic',
                },
            ],
        });
    },
    input: {
        class: 'tw-hidden',
    },
    header: {
        class: [
            // Flexbox
            'tw-flex',
            'tw-flex-wrap',
            'tw-justify-between',
            // Colors
            'tw-bg-gray-50',
            'dark:tw-bg-gray-800',
            'tw-text-gray-700',
            'dark:tw-text-white/80',
            // Spacing
            'tw-p-5',
            'tw-gap-2',
            // Borders
            'tw-border',
            'tw-border-solid',
            'tw-border-gray-200',
            'dark:tw-border-gray-700',
            'tw-border-b-0',
            // Shape
            'tw-rounded-tr-md',
            'tw-rounded-tl-md',
        ],
    },
    pcUploadButton: function (_a) {
        var props = _a.props;
        return ({
            root: {
                class: [
                    {
                        'tw-hidden': props.auto,
                    },
                ],
            },
        });
    },
    pcChooseButton: {
        root: {
            class: [BUTTON_CLASSES.BASE, BUTTON_CLASSES.SEVERITY.PRIMARY, 'tw-text-base tw-px-3 tw-py-1.5', 'tw-max-w-fit', 'tw-gap-1'],
        },
    },
    pcCancelButton: {
        root: {
            class: [BUTTON_CLASSES.BASE, BUTTON_CLASSES.SEVERITY.SECONDARY, 'tw-text-base tw-px-3 tw-py-1.5', 'tw-max-w-fit', 'tw-gap-1'],
        },
    },
    pcFileRemoveButton: {
        root: {
            class: [BUTTON_CLASSES.BASE, BUTTON_CLASSES.SEVERITY.DANGER, 'tw-text-sm tw-px-1 tw-py-1', 'tw-max-w-fit', 'tw-gap-1'],
        },
        label: {
            class: 'tw-hidden',
        },
    },
    content: {
        class: [
            // Position
            'tw-relative',
            // Colors
            'tw-bg-white-0',
            'dark:tw-bg-gray-900',
            'tw-text-gray-700',
            'dark:tw-text-white/80',
            // Spacing
            'tw-p-6',
            // Borders
            'tw-border',
            'tw-border-gray-200',
            'dark:tw-border-gray-700',
            // Shape
            'tw-rounded-b-md',
            //ProgressBar
            '[&>[data-pc-name=pcprogressbar]]:tw-absolute',
            '[&>[data-pc-name=pcprogressbar]]:tw-w-full',
            '[&>[data-pc-name=pcprogressbar]]:tw-top-0',
            '[&>[data-pc-name=pcprogressbar]]:tw-left-0',
            '[&>[data-pc-name=pcprogressbar]]:tw-h-1',
        ],
    },
    file: {
        class: [
            // Flexbox
            'tw-flex',
            'tw-items-center',
            'tw-flex-wrap',
            // Spacing
            'tw-p-4',
            'tw-mb-2',
            'last:tw-mb-0',
            // Borders
            'tw-border',
            'tw-border-gray-200',
            'dark:tw-border-gray-700',
            'tw-gap-2',
            // Shape
            'tw-rounded',
        ],
    },
    fileThumbnail: 'tw-shrink-0',
    fileName: 'tw-mb-2 tw-break-all',
    fileSize: 'tw-mr-2',
};
